import { BoardValue } from '../../jscaip/AI/BoardValue';
import { Heuristic } from '../../jscaip/AI/Heuristic';
import { HexodiaRules } from './HexodiaRules';
export class HexodiaAlignmentHeuristic extends Heuristic {
    getBoardValue(node, config) {
        const state = node.gameState;
        let score = 0;
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            const squareScore = HexodiaRules
                .getHexodiaHelper(config)
                .getSquareScore(state, coordAndContent.coord);
            score += squareScore;
        }
        return BoardValue.of(score);
    }
}
